import React, { useState, useEffect } from 'react';
import './OpenEndMeetingForAll.css'; // Add your CSS file for styling
import axios from 'axios';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { encryptWithManagedIV } from '../../utils/DecryptingModule';
import useChatContext from '../../hooks/useChatContext/useChatContext';

export default function OpenEndMeetingForAll() {
  const { room } = useVideoContext();
  const history = useHistory();
  const { messages, conversation } = useChatContext();
  // const { search, state } = useLocation();
  // const [input, setInput] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  // const { URLRoomName } = useParams<{ URLRoomName?: string }>();
  // const [roomName, setRoomName] = useState<string>('');
  // const [UserName, setUserName] = useState<string>('');
  // const [Link, Setlink] = useState<string>('');
  const { search, state } = useLocation();
  const ContactPhoneNumber = (state as { state: { ContactPhoneNumber: string } }).state.ContactPhoneNumber;
  const RecordId = (state as { state: { RecordId: string } }).state.RecordId;
  const ContactName = (state as { state: { ContactName: string } }).state.ContactName;
  const ProviderId = (state as { state: { ProviderId: string } }).state.ProviderId;
  const Type = (state as { state: { Type: string } }).state.Type;
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const Approve = async () => {
    // conversation?.sendMessage(`disconnectedall/disconnectedall`);
    const config = {
      headers: {
        Authorization:
          'Bearer 00D7h000000HAcA!AQEAQJ5mc5l.Hc.kC9lL1vP2Anp1BZHpMpF88zbK0KsR25LvSBX7WtNC8O0sSogrrRtS_vPMUEa94eJIc0cE1oLsN_ALVecG',
      },
    };
    if (Type == 'Host') {
      await axios.get(`https://avserver.jobsitecare.com/close/${ProviderId + RecordId}`);
      await axios
        .get('https://avserver.jobsitecare.com/salesforce/token')
        .then(async response => {
          //console.log(response, 'tokena');
          const config = {
            headers: {
              Authorization: `Bearer ${response.data}`,
            },
          };
          try {
            const response = await axios.post(
              `https://jobsitecare.my.salesforce.com/services/apexrest/CallStatus`,
              {
                recordId: RecordId,
                status: 'Ended',
              },
              config
            );
            //console.log(response);
          } catch (err) {
            //console.log(err);
          }
        })
        .catch(error => {
          //console.log(error);
          // handle the error
        });
      await axios.get(`https://avserver.jobsitecare.com/endcall/:${ProviderId}${RecordId}`);
      history.replace('/end');
    }
    // room!.disconnect();
  };
  const Cancel = () => {
    // history.replace('/end');
    // room!.disconnect();
    document.getElementById('closebutton')?.click();
  };
  // Capture global keyboard events
  // useEffect(()=>{
  // }})
  return (
    <div className="button-container chatbox">
      <div className="row">Are you sure you want to end the meeting?</div>
      <div className="row">
        {' '}
        <button className="callbtn" onClick={Approve}>
          Yes
        </button>{' '}
      </div>
      <div className="row">
        {' '}
        <button className="callbtn" onClick={Cancel}>
          Cancel
        </button>{' '}
      </div>

      {/* 
      <div className="button-container">
        <div className="button-container">
          <div className="row">
          </div>
          <div className="row">          
          </div>
          <div className="row">         
          </div>
          <div className="row">
          </div>
          <div className="row"></div>
          <div className="row buttonssms">
             <button onClick={Participants} className="callbtn">
              participants
            </button> 
          </div>
        </div>
      </div> */}
    </div>
  );
}
